'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createAccountTrigger = require('hellosign/components/auth/create-account-trigger');

var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _city_overlay_left = require('landing-pages/assets/city_overlay_left.svg');

var _city_overlay_left2 = _interopRequireDefault(_city_overlay_left);

var _city_overlay_right = require('landing-pages/assets/city_overlay_right.svg');

var _city_overlay_right2 = _interopRequireDefault(_city_overlay_right);

var _document_send_icon = require('landing-pages/assets/document_send_icon.svg');

var _document_send_icon2 = _interopRequireDefault(_document_send_icon);

var _signature_icon = require('landing-pages/assets/signature_icon.svg');

var _signature_icon2 = _interopRequireDefault(_signature_icon);

var _handshake_icon = require('landing-pages/assets/handshake_icon.svg');

var _handshake_icon2 = _interopRequireDefault(_handshake_icon);

var _hubspot_crm_integration_header = require('landing-pages/assets/hubspot_crm_integration_header.svg');

var _hubspot_crm_integration_header2 = _interopRequireDefault(_hubspot_crm_integration_header);

var _hubspot_logo = require('landing-pages/assets/hubspot_logo.svg');

var _hubspot_logo2 = _interopRequireDefault(_hubspot_logo);

var _screenshot_hubspot_crm_animated = require('landing-pages/assets/screenshot_hubspot_crm_animated.gif');

var _screenshot_hubspot_crm_animated2 = _interopRequireDefault(_screenshot_hubspot_crm_animated);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

var _ctaButton = require('landing-pages/components/common/cta-button');

var _ctaButton2 = _interopRequireDefault(_ctaButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function HubSpotLandingPage(p) {
    // HubSpot constants
    var benefits = [{
        icon: _handshake_icon2['default'],
        title: 'Close Contracts Faster',
        text: 'The average turnaround time for a contract is 44 minutes when using HelloSign. Seal those deals even faster!'
    }, {
        icon: _signature_icon2['default'],
        title: 'Request and Track Signatures',
        text: 'Make it easy to organize and follow-up on any eSignature request in your HubSpot CRM. You\'ll never have to worry about hunting down a document again.'
    }, {
        icon: _document_send_icon2['default'],
        title: 'Templates for High-volume Documents',
        text: 'Auto-populate high volume documents with information using our templates and merge fields. Create once, reuse again and again.'
    }];
    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40HubSpot%3F%20Send%20contracts%20for%20signature%20directly%20from%20HubSpot%20CRM.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm%3Futm_campaign%3DHUB-101515%26utm_medium%3Ds2s%26utm_source%3Dtwitter';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/hubspot-crm?utm_source=facebook%26utm_medium=s2s';
    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm%3Futm_campaign%3DHUB-101515%26utm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
    var border = '2px solid #D7D7D7';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations hubspot-crm' },
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(HowItWorks, p),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/211846118-Hubspot-Integration' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function IllustrationArea(p) {
    var imageStyle = { transform: 'translateY(1px)' };
    return _react2['default'].createElement(
        'div',
        { className: 'top row hubspot-orange' },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _hubspot_logo2['default'], alt: 'HubSpot Logo', className: 'dropbox-logo', width: '130' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Send contracts directly from HubSpot CRM'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
                    'Integrate HelloSign with HubSpot CRM to request signatures, track lifecycle status, and manage contracts out for signature. Sort your documents by last viewed or signature status to know when to follow up with leads before they get cold.'
                )
            ),
            _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, { buttonText: 'Get started' }))
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _hubspot_crm_integration_header2['default'], alt: 'cityscape', style: { marginTop: 23 } })
        ),
        _react2['default'].createElement('img', { src: _city_overlay_left2['default'],
            style: imageStyle,
            alt: 'city left',
            className: 'cloud-left'
        }),
        _react2['default'].createElement('img', { src: _city_overlay_right2['default'],
            style: imageStyle,
            alt: 'city right',
            className: 'cloud-right'
        })
    );
}

function CTALink(p) {
    var linkURL = '/home/myAccount#integrations';

    // Return standard link if user is already logged in
    if (p.isUserLoggedIn) {
        return _react2['default'].createElement(
            'a',
            { href: linkURL },
            p.linkText
        );
    }

    // Otherwise, create a trigger so we can display the signup modal
    var trigger = _react2['default'].createElement(
        'a',
        null,
        p.linkText
    );
    return _react2['default'].createElement(_createAccountTrigger2['default'], _extends({}, p, {
        trigger: trigger,
        redirectUrl: linkURL,
        homeUrl: linkURL,
        googleOpenIdUrl: p.googleOpenIdLocationUrl,
        header: 'Get Started' }));
}

function HowItWorks(p) {
    var linkURL = 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/';
    var link = _react2['default'].createElement(
        'a',
        { href: linkURL },
        'Read our blog post'
    );
    var paragraphStyle = {
        marginLeft: 20
    };

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-3 large-push-9 columns' },
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'To get started,',
                    _react2['default'].createElement(CTALink, _extends({ linkText: ' activate the HubSpot CRM integration ' }, p)),
                    'on your settings page and insert your Hub ID.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'Then you\u2019ll be able to track documents in your HubSpot contact feeds, request signatures within HubSpot, autofill documents with a contact\u2019s information, and access your completed documents.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'Want to learn more about the integration? ',
                    link,
                    '.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
                _react2['default'].createElement('img', { src: _screenshot_hubspot_crm_animated2['default'], alt: 'hubspot screenshot' })
            )
        )
    );
}

module.exports = HubSpotLandingPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/hubspot-crm-landing-page.jsx
 ** module id = 1523
 ** module chunks = 0
 **/